export default __webpack_public_path__ + "static/media/atzzo.1fbe6871.jpg";